import BaseColorPicker from "./BaseColorPicker.vue";

export default BaseColorPicker;
